var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { Text, View } from 'react-native';
import { isAnonymousUserAtom, useMe } from '@/atoms/Auth';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { useUpdateMarketingPushAgreement } from '@/utils/marketingPushAgreement';
export default function MarketingPushAgreementRow() {
    var _a;
    const { userInfo } = useMe();
    const isAnonymousUser = useAtomValue(isAnonymousUserAtom);
    const updateAgreement = useUpdateMarketingPushAgreement();
    // 낙관적 업데이트용. null 이면 서버 값을 그대로 쓴다. 실패 시 null 로 되돌려 롤백.
    const [optimistic, setOptimistic] = useState(null);
    if (isAnonymousUser)
        return null;
    const value = (_a = optimistic !== null && optimistic !== void 0 ? optimistic : userInfo === null || userInfo === void 0 ? void 0 : userInfo.isMarketingPushAgreed) !== null && _a !== void 0 ? _a : false;
    function onToggle(next) {
        return __awaiter(this, void 0, void 0, function* () {
            setOptimistic(next);
            yield updateAgreement(next);
            setOptimistic(null);
        });
    }
    return (_jsxs(View, { className: "px-5 py-5", children: [_jsx(Text, { className: "mb-[8px] font-pretendard-regular text-[14px] leading-[20px] text-gray-50", children: "\uB9C8\uCF00\uD305 \uC815\uBCF4 \uC218\uC2E0 \uB3D9\uC758" }), _jsxs(View, { className: "flex-row items-center justify-between", children: [_jsx(Text, { className: "font-pretendard-medium text-[16px] leading-[26px] text-black", children: "\uC774\uBCA4\uD2B8\u00B7\uD61C\uD0DD \uC18C\uC2DD\uC744 \uD478\uC2DC\uB85C \uBC1B\uC544\uC694" }), _jsx(Toggle, { value: value, onChange: onToggle })] })] }));
}
// ponytail: RN 기본 Switch 는 iOS 26 에서 실제 크기가 레이아웃보다 커서 우측 여백을 넘고, off 트랙이 배경과 구분되지 않아
// 크기·색을 직접 정하는 토글로 그린다. 다른 화면에서도 필요해지면 components 로 올린다.
function Toggle({ value, onChange, }) {
    return (_jsx(SccPressable, { elementName: "setting_marketing_push_agreement_toggle", logParams: { next: !value }, accessibilityRole: "switch", accessibilityState: { checked: value }, hitSlop: 8, onPress: () => onChange(!value), className: "h-[28px] w-[48px] justify-center rounded-full px-[3px]", style: { backgroundColor: value ? color.brand30 : color.gray30 }, children: _jsx(View, { className: "h-[22px] w-[22px] rounded-full bg-white", style: { alignSelf: value ? 'flex-end' : 'flex-start' } }) }));
}
